import { differenceInHours, getHours } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const extractDateFromISOString = (date: string) => {
	return date.split('T')[0];
};

export const dateIsInPast = (date: Date) => {
	const today = new Date();
	today.setHours(0, 0, 0, 0);

	const inputDate = new Date(date); // create a copy
	inputDate.setHours(0, 0, 0, 0);

	return inputDate < today;
};

export const timeSlotSpansOneDay = (startDatetime: string, endDatetime: string, timezone: string): boolean => {
	const startDate = new Date(startDatetime);
	const endDate = new Date(endDatetime);

	// Convert to target timezone
	const zonedStartDate = toZonedTime(startDate, timezone);

	// Check if start time is exactly 00:00:00
	const isStartAtMidnight = zonedStartDate.getHours() === 0 && zonedStartDate.getMinutes() === 0 && zonedStartDate.getSeconds() === 0;

	// Check if difference is exactly 24 hours
	const hoursDifference = differenceInHours(endDate, startDate);

	return isStartAtMidnight && hoursDifference === 24;
};

export const formatFullDate = (startDatetime: string, endDatetime: string, locale: string, timezone: string) => {
	const startDate = new Date(startDatetime);
	const endDate = new Date(endDatetime);

	const baseOptions: Intl.DateTimeFormatOptions = {
		weekday: 'short',
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	};

	if (timeSlotSpansOneDay(startDatetime, endDatetime, timezone)) {
		// Full day slot - only show date
		const formatter = new Intl.DateTimeFormat(locale, baseOptions);
		return formatter.format(startDate);
	}

	// Not a full day - include time
	const optionsWithTime: Intl.DateTimeFormatOptions = {
		...baseOptions,
		hour: 'numeric',
		minute: 'numeric',
		timeZone: timezone,
		timeZoneName: 'short',
	};

	const formatter = new Intl.DateTimeFormat(locale, optionsWithTime);
	return formatter.formatRange(startDate, endDate);
};

export const formatDateRange = (startDate: Date, endDate: Date, locale: string, timezone: string) => {
	const rangeFormat = new Intl.DateTimeFormat(locale, {
		hour: '2-digit',
		minute: '2-digit',
		timeZoneName: 'short',
		timeZone: timezone,
	});

	return rangeFormat.formatRange(startDate, endDate);
};

export const getLocalHour = (isoString: string, timezone: string): number => {
	const date = new Date(isoString);
	const zonedDate = toZonedTime(date, timezone);
	return getHours(zonedDate);
};
